import { createAction, props } from '@ngrx/store';

import {
    ICallableUpdateProfile,
    ICallableValidCurrentPass,
    ICallableValidNewPhone,
    IResultGetProfile,
    IResultUpdateProfile
} from '../../shared/models/Profile';

/*
 * Consulta los datos de perfil y configuracion para el modulo
 */
export const getProfile = createAction(
    '[Profile] Get Profile'
);

export const successGetProfile = createAction(
    '[Profile] Success Get Profile',
    props<IResultGetProfile>()
);

export const errorGetProfile = createAction(
    '[Profile] Error Get Profile',
    props<{ payload: Error }>()
);

/*
 * Actualiza datos del perfil
 */
export const updateProfile = createAction(
    '[UpdateProfile] Update Profile',
    props<ICallableUpdateProfile>()
);

export const successUpdateProfile = createAction(
    '[UpdateProfile] Success Update Profile',
    props<IResultUpdateProfile>()
);

export const errorUpdateProfile = createAction(
    '[UpdateProfile] Error Update Profile',
    props<{ payload: Error }>()
);

export const clearUpdateProfile = createAction(
    '[UpdateProfile] Clear Update Profile'
);

/*
 * Valida la contraseña actual
 */
export const validCurrentPass = createAction(
    '[ValidCurrentPass] Valid Current Pass',
    props<ICallableValidCurrentPass>()
);

export const successValidCurrentPass = createAction(
    '[ValidCurrentPass] Success Valid Current Pass',
    props<IResultUpdateProfile>()
);

export const errorValidCurrentPass = createAction(
    '[ValidCurrentPass] Error Valid Current Pass',
    props<{ payload: Error }>()
);

export const clearValidCurrentPass = createAction(
    '[ValidCurrentPass] Clear Valid Current Pass'
);

/*
 * Valida nuevo teléfono
 */
export const validNewPhone = createAction(
    '[ValidNewPhone] Valid new phone',
    props<ICallableValidNewPhone>()
);

export const successValidNewPhone = createAction(
    '[ValidNewPhone] Success Valid new phone',
    props<{ code: number, message: string }>()
);

export const errorValidNewPhone = createAction(
    '[ValidNewPhone] Error Valid new phone',
    props<{ payload: Error }>()
);

export const clearValidNewPhone = createAction(
    '[ValidNewPhone] Clear Valid new phone'
);
